module.exports = __webpack_public_path__ + "img/comments-question.5578f071.svg";